import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const depositVuex = createNamespacedHelpers("deposit");
export default {
  name: "popStarDeposit",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    ...userVuex.mapState(["userData"])
  },
  data() {
    return {
      amountList: [100, 500, 1000, 2000, 5000, 10000]
    };
  },
  props: {},
  watch: {
    "$parent.popStarDepositShow": {
      handler(newVal, oldVal) {
        if (!newVal && typeof oldVal !== 'undefined') {
          this.$parent.popStarDepositShow = false;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...depositVuex.mapActions(["doDeposit", "getDepositLogStatus"]),
    async toDoDeposit(amount) {
      await this.doDeposit(['telegram', 'Stars', amount, '', async res => {
        if (res && res.payment_url) {
          this.WebApp.openInvoice(res.payment_url, status => {
            //if(status == 'paid'){

            //}
            //else{
            this.getDepositLogStatus([res.deposit_id, 'deposit', re => {
              this.$emit("accept");
              this.$parent.popStarDepositShow = false;
            }, () => {}]);
            //}
          });
        }
      }]);
    }
  }
};